import React from 'react';
import * as PropTypes from 'prop-types';
import { Typography } from 'antd';
import './ViaFields.css';
import { FormattedMessage } from 'react-intl';
import { displayAddressSingleLine } from '../../sections/secured/configure/company/user-util';

const { Text } = Typography;


export default function DisplayAddress({
  address,
  className,
  withLineBreaks,
}) {
  if (!address || !address.line1) {
    return (<Text className={className}><FormattedMessage id="noAddressProvided" /></Text>);
  }

  const displayAddressMultiLine = () => {
    if (!address) return <></>;

    return (
      <Text className={className}>
        {address.line1}
        <br />
        {address.line2}
        {address.line2 ? <br /> : null}
        {address.line3}
        {address.line3 ? <br /> : null}
        {address.line4}
        {address.line4 ? <br /> : null}
        {address.region}
        {address.region ? <br /> : null}
        {address.zipPostcode}
        {address.zipPostcode ? <br /> : null}
        {address.countryDescription}
      </Text>
    );
  };

  const addressString = withLineBreaks ? displayAddressMultiLine(address) : displayAddressSingleLine(address);

  return (
    <Text className={className}>{addressString}</Text>
  );
}

DisplayAddress.propTypes = {
  className: PropTypes.string,
  address: PropTypes.shape({
    line1: PropTypes.string.isRequired,
    line2: PropTypes.string,
    line3: PropTypes.string,
    line4: PropTypes.string,
    region: PropTypes.string,
    zipPostcode: PropTypes.string,
    countryDescription: PropTypes.string.isRequired,
  }),
  withLineBreaks: PropTypes.bool,
};

DisplayAddress.defaultProps = {
  className: null,
  withLineBreaks: true,
  address: null,
};
